/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBabyAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g clipRule="evenodd" fill="currentcolor" fillRule="evenodd">
        <path d="M12 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
        <path d="M12 1a7 7 0 0 1 7 7v8a7 7 0 1 1-14 0V8a7 7 0 0 1 7-7zM7 16a5 5 0 0 0 8.924 3.096L7 13.943zm6.428-.655 3.398 1.962C16.94 16.89 17 16.452 17 16v-2.592zM12 3a5 5 0 0 0-5 5v3.634l4.396 2.537L17 11.134V8a5 5 0 0 0-5-5z" />
      </g>
    </g>
  </Icon>
);
export { SvgBabyAlt as BabyAlt };
